export default [
  {
    key: 'games',
    path: '/games',
    name: 'games',
    route: 'games',
    header: 'games',
    meta: {
      authRequired: true,
      isAppMenu: true,
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        key: 'agent:view.game_history',
        path: '/games/history',
        name: 'game_history',
        route: 'game_history',
        icon: 'ClipboardIcon',
        component: () => import('@/views/games/History.vue'),
        meta: {
          authRequired: true,
          isAppMenu: true,
          breadcrumb: [],
          icon: 'ClipboardIcon',
        },
      },
      {
        key: 'agent:view.game_history_detail',
        path: '/game/history/detail/:id',
        name: 'game_history_detail',
        route: 'game_history_detail',
        icon: 'ClipboardIcon',
        component: () => import('@/views/games/HistoryDetail.vue'),
        meta: {
          authRequired: true,
          isAppMenu: false,
          breadcrumb: [
            {
              name: 'game_history',
              to: '/games/history',
            },
            {
              name: 'game_history_detail',
              active: true,
              isUseId: true,
            },
          ],
        },
      },
    ],
  },
]
